import type { ExpressionTerm, DataRouteTerm } from 'flow/store/engine/types';


export function isDataRouteExpressionTerm(
  term: ExpressionTerm | ExpressionTerm[],
): term is DataRouteTerm {
  if (term instanceof Object && !Array.isArray(term) && Object.hasOwn(term, 'data_route_id')) {
    return true;
  }

  return false;
}
